import { DistanceUnitsEnum } from '@ubnt/link-core/enums';
import { availableCountries } from '@ubnt/wifi-calculator/utils/regulatoryLimits';

export interface SettingsState {
  isVisible: boolean;
  country: string;
  userCountry?: string;
  ceilingHeight: number;
  showDeviceName: boolean;
  showAnimation: boolean;
  unit: ValuesOf<typeof DistanceUnitsEnum>;
}

export const isStoredSettingsValid = (settings: Partial<SettingsState>) => {
  if (settings.country == null || !availableCountries.includes(settings.country)) {
    return false;
  }
  if (settings.ceilingHeight !== undefined && typeof settings.ceilingHeight !== 'number') {
    return false;
  }
  if (settings.showDeviceName !== undefined && typeof settings.showDeviceName !== 'boolean') {
    return false;
  }
  if (settings.showAnimation !== undefined && typeof settings.showAnimation !== 'boolean') {
    return false;
  }
  if (settings.unit !== undefined && !Object.values(DistanceUnitsEnum).includes(settings.unit)) {
    return false;
  }

  return true;
};
